import { render, staticRenderFns } from "./FormCreateEditPage.vue?vue&type=template&id=96c4b12e&"
import script from "./FormCreateEditPage.vue?vue&type=script&lang=js&"
export * from "./FormCreateEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports